import { cloneDeep, values } from 'lodash';
import { Component, computed, inject, input, Signal, signal } from '@angular/core';
import { ModalSingleComponent } from "../../../../../shared/components/modal-single/modal-single.component";
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgIf } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from 'src/app/services/user.service';
import * as dayjs from 'dayjs';

enum MODAL_MODE {
  add, edit
}

@Component({
  selector: 'app-perform-log-evidence-modal',
  imports: [ModalSingleComponent, ReactiveFormsModule, NgIf],
  templateUrl: './perform-log-evidence-modal.component.html',
  styleUrl: './perform-log-evidence-modal.component.scss'
})
export class PerformLogEvidenceModalComponent {
  private _activeModal = inject(NgbActiveModal);
  userService = inject(UserService);
  editedEvidenceForm: Signal<FormGroup> = input();
  modalMode = computed(() => this.editedEvidenceForm() ? MODAL_MODE.edit : MODAL_MODE.add);
  evidenceForm: Signal<FormGroup> = computed(() => {
    console.log('this.userService.user.value?.userID',this.userService.user.value?.userID)
    return this.modalMode() === MODAL_MODE.edit ? (cloneDeep(this.editedEvidenceForm() as FormGroup)) : new FormGroup({
      title: new FormControl<string>(null, Validators.required),
      link: new FormControl<string>(null, Validators.required),
      description: new FormControl<string>(null),
    })
  });

  attachEvidence() {
    this._activeModal.close(this.evidenceForm().value);
  }

  close() {
    this._activeModal.close();
  }

}
